import { DateTime } from 'luxon';
import { HistoricalPerDiemCalendarPeriod } from 'pages/Shipments/HistoricalPerDiem/params';
import { centsToDollars } from 'utils/container-transforms';

export const formatDate = (date: string) =>
  DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('LLL dd');
export const formatDollars = (value: number) => centsToDollars(value, false);

export const formatDateWithCalendarPeriod: (
  date: string,
  calendarPeriod: HistoricalPerDiemCalendarPeriod
) => string = (date, calendarPeriod) => {
  const dateObj = DateTime.fromFormat(date, 'yyyy-MM-dd');

  if (!dateObj.isValid) {
    return date;
  }

  switch (calendarPeriod) {
    case HistoricalPerDiemCalendarPeriod.Quarter:
      return `Q${dateObj.toFormat('q yyyy')}`;
    case HistoricalPerDiemCalendarPeriod.Month:
      return dateObj.toFormat('MMM yyyy');
    case HistoricalPerDiemCalendarPeriod.Week:
      return `W${dateObj.toFormat('W yyyy')}`;
    case HistoricalPerDiemCalendarPeriod.Day:
    default:
      return dateObj.toFormat('LLL dd');
  }
};

export const formatGetWeekRange: (date: string) => string = (date) => {
  const dateObj = DateTime.fromFormat(date, 'yyyy-MM-dd');

  if (!dateObj.isValid) {
    return date;
  }

  const startOfWeek = dateObj.startOf('week').toFormat('LLL dd');
  const endOfWeek = dateObj.endOf('week').toFormat('LLL dd');

  return `${startOfWeek} - ${endOfWeek}`;
};
